import { RouterModule, Routes } from '@angular/router';

let routes: Routes = [
  {
    path: '',
    loadChildren: () => import('../pages/bursa-nivel-1/bursa-nivel-1.module').then((m) => m.BursaNivel1Module),
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: '/',
    pathMatch: 'full',
  },
];

export const AppRouting = RouterModule.forRoot(routes, {
    initialNavigation: 'enabledBlocking'
});
